<template>
  <div class="header">
    <hamburger-button v-if="mobileMode" class="left white" :tabindex="0" />
    <div class="header-message" :class="{ 'header-message-small': mobileMode }">
      <span>{{ $t('app.dashboardBannerHeader.headerMessage') }}</span>
    </div>
    <a
      v-if="productFlags.fallIncentiveProgram"
      href="https://upchieve.org/upchieve-fall-challenge-2023"
      target="_blank"
      rel="noopener noreferrer"
      class="header-button"
    >
      {{ $t('app.dashboardBannerHeader.learnMoreButton') }}
      <arrow-right-icon v-if="dir == 'ltr'" class=" arrow-icon" />
      <arrow-left-icon v-else-if="dir == 'rtl'" class=" arrow-icon" />
    </a>
    <span
      @click="toggleFallIncentiveEnrollmentModal"
      class="header-button"
      v-else
    >
      {{ $t('app.dashboardBannerHeader.enrollButton') }}
    </span>
    <fall-incentive-enrollment-modal
      v-if="showFallIncentiveEnrollmentModal"
      :closeModal="toggleFallIncentiveEnrollmentModal"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ArrowLeftIcon from '@/assets/left-arrow.svg'
import ArrowRightIcon from '@/assets/arrow.svg'
import FallIncentiveEnrollmentModal from '@/views/DashboardView/StudentDashboard/FallIncentiveEnrollmentModal.vue'
import HamburgerButton from './HamburgerButton.vue'

export default {
  name: 'dashboard-banner-header',
  components: {
    ArrowLeftIcon,
    ArrowRightIcon,
    FallIncentiveEnrollmentModal,
    HamburgerButton,
  },
  data() {
    return { showFallIncentiveEnrollmentModal: false }
  },
  computed: {
    ...mapState({
      productFlags: state => state.productFlags.flags,
    }),
    ...mapGetters({
      mobileMode: 'app/mobileMode',
      dir: 'app/direction',
    }),
  },
  methods: {
    toggleFallIncentiveEnrollmentModal() {
      this.showFallIncentiveEnrollmentModal = !this
        .showFallIncentiveEnrollmentModal
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  @include header-child;
  display: flex;
  align-items: center;
  background-color: $c-information-blue;

  &-message {
    margin-left: auto;
    color: $upchieve-white;

    & span {
      font-weight: 500;
    }

    &-small {
      font-size: 14px;
      margin-left: 48px;
    }
  }

  &-button {
    margin-left: auto;
    color: $c-soft-black;
    background-color: $upchieve-white;
    border: none;
    border-radius: 20px;
    padding: 0.4em 1.2em;
    font-weight: 600;
    @include flex-container(row, flex-start, center);

    &:hover {
      background-color: darken($upchieve-white, 5%);
    }
  }
}

.arrow-icon {
  fill: currentColor;
  height: 16px;
  width: 16px;
  margin-left: 0.6em;
}

.left {
  left: 15px;
  position: absolute;
  top: 15px;
}

.white {
  fill: white;
}

html.is-rtl {
  .header {
    &-message {
      margin-right: auto;
      margin-left: unset;

      &-small {
        margin-right: 48px;
        margin-left: unset;
      }
    }

    &-button {
      margin-right: auto;
      margin-left: unset;
    }
  }

  .arrow-icon {
    margin-right: 0.6em;
    margin-left: unset;
  }

  .left {
    right: 15px;
    left: unset;
  }
}
</style>
